export const loyaltyTiers = [
  {
    id: 'bronze',
    name: 'Bronze',
    minPoints: 0,
    maxPoints: 999,
    color: '#CD7F32',
    benefits: ['1 point per GHS 1 spent', 'Birthday discount 5%', 'Access to sales events'],
    icon: 'ri-medal-line',
    customers: 1240,
  },
  {
    id: 'silver',
    name: 'Silver',
    minPoints: 1000,
    maxPoints: 4999,
    color: '#C0C0C0',
    benefits: ['1.5 points per GHS 1 spent', 'Birthday discount 10%', 'Free screen protector yearly', 'Priority repair queue'],
    icon: 'ri-vip-crown-line',
    customers: 456,
  },
  {
    id: 'gold',
    name: 'Gold',
    minPoints: 5000,
    maxPoints: 14999,
    color: '#FFD700',
    benefits: ['2 points per GHS 1 spent', 'Birthday discount 15%', 'Free case + protector yearly', 'Express delivery', 'Exclusive early access'],
    icon: 'ri-vip-diamond-line',
    customers: 128,
  },
  {
    id: 'platinum',
    name: 'Platinum',
    minPoints: 15000,
    maxPoints: 999999,
    color: '#E5E4E2',
    benefits: ['3 points per GHS 1 spent', 'Birthday discount 20%', 'Free accessories bundle yearly', 'Personal account manager', 'VIP repair (same day)', 'Free delivery nationwide'],
    icon: 'ri-vip-crown-2-line',
    customers: 34,
  },
];

export const loyaltyCustomers = [
  {
    id: 'lc1',
    name: 'Kwame Asante',
    avatar: 'https://readdy.ai/api/search-image?query=young%20african%20man%20portrait%20headshot%20professional%20warm%20lighting&width=80&height=80&seq=lc1&orientation=squarish',
    tier: 'Platinum',
    points: 18750,
    lifetimeSpend: 18750,
    visits: 34,
    lastVisit: 'Apr 20, 2026',
    rewardsRedeemed: 12,
    nextReward: 'Free iPhone case (20,000 pts)',
  },
  {
    id: 'lc2',
    name: 'Ama Owusu',
    avatar: 'https://readdy.ai/api/search-image?query=young%20african%20woman%20smiling%20portrait%20headshot%20warm%20lighting&width=80&height=80&seq=lc2&orientation=squarish',
    tier: 'Gold',
    points: 8200,
    lifetimeSpend: 8200,
    visits: 18,
    lastVisit: 'Apr 18, 2026',
    rewardsRedeemed: 5,
    nextReward: 'Free screen protector (10,000 pts)',
  },
  {
    id: 'lc3',
    name: 'Kofi Mensah',
    avatar: 'https://readdy.ai/api/search-image?query=young%20ghanaian%20man%20portrait%20headshot%20casual%20warm%20lighting&width=80&height=80&seq=lc3&orientation=squarish',
    tier: 'Gold',
    points: 6400,
    lifetimeSpend: 6400,
    visits: 14,
    lastVisit: 'Apr 15, 2026',
    rewardsRedeemed: 3,
    nextReward: 'Free screen protector (10,000 pts)',
  },
  {
    id: 'lc4',
    name: 'Efua Boateng',
    avatar: 'https://readdy.ai/api/search-image?query=african%20woman%20professional%20headshot%20warm%20smile%20simple%20background&width=80&height=80&seq=lc4&orientation=squarish',
    tier: 'Silver',
    points: 3200,
    lifetimeSpend: 3200,
    visits: 9,
    lastVisit: 'Apr 12, 2026',
    rewardsRedeemed: 2,
    nextReward: 'GHS 50 off (5,000 pts)',
  },
  {
    id: 'lc5',
    name: 'Yaw Darko',
    avatar: 'https://readdy.ai/api/search-image?query=young%20african%20man%20portrait%20headshot%20friendly%20expression%20warm%20lighting&width=80&height=80&seq=lc5&orientation=squarish',
    tier: 'Silver',
    points: 2100,
    lifetimeSpend: 2100,
    visits: 7,
    lastVisit: 'Apr 10, 2026',
    rewardsRedeemed: 1,
    nextReward: 'GHS 50 off (5,000 pts)',
  },
  {
    id: 'lc6',
    name: 'Abena Kusi',
    avatar: 'https://readdy.ai/api/search-image?query=african%20woman%20student%20portrait%20headshot%20bright%20smile%20simple%20background&width=80&height=80&seq=lc6&orientation=squarish',
    tier: 'Bronze',
    points: 450,
    lifetimeSpend: 450,
    visits: 3,
    lastVisit: 'Apr 5, 2026',
    rewardsRedeemed: 0,
    nextReward: 'GHS 20 off (1,000 pts)',
  },
];

export const loyaltyRewards = [
  { id: 'r1', name: 'GHS 20 Off', points: 1000, value: 20, category: 'Discount', redeemed: 89 },
  { id: 'r2', name: 'GHS 50 Off', points: 5000, value: 50, category: 'Discount', redeemed: 45 },
  { id: 'r3', name: 'GHS 100 Off', points: 10000, value: 100, category: 'Discount', redeemed: 23 },
  { id: 'r4', name: 'Free Screen Protector', points: 10000, value: 80, category: 'Accessory', redeemed: 67 },
  { id: 'r5', name: 'Free Phone Case', points: 20000, value: 150, category: 'Accessory', redeemed: 34 },
  { id: 'r6', name: 'Free Accessories Bundle', points: 50000, value: 400, category: 'Bundle', redeemed: 12 },
  { id: 'r7', name: 'Express Repair', points: 15000, value: 200, category: 'Service', redeemed: 18 },
  { id: 'r8', name: 'Free Delivery', points: 8000, value: 50, category: 'Service', redeemed: 29 },
];

export const loyaltyStats = {
  totalMembers: 1858,
  activeMembers: 1240,
  totalPointsIssued: 456000,
  totalPointsRedeemed: 187000,
  avgPointsPerMember: 245,
  retentionRate: 67.2,
  revenueFromLoyalty: 187000,
  topTierPercentage: 1.8,
};